import { getDomainName, isAlgoDeltaDomain } from "./helper_functions";
import { LOGO_TYPE } from "./key_helper";
export const APP_VERSION = "v1.1.28";
export const ENV = "LIVE";   // Change this to "BETA", "LIVE" or "LOCAL" as needed
//API CONFIGURATION
const CONFIG = {
    LIVE: {
        BASE_URL: "https://apiv4.algodelta.com",
        SOCKET_URL: "https://socketv4.algodelta.com",
    },
    BETA: {
        BASE_URL: "https://betabv4.algodelta.com",
        SOCKET_URL: "https://betasv4.algodelta.com",
    },
    LOCAL: {
        BASE_URL: "http://192.168.1.29:3000",
        SOCKET_URL: "http://192.168.1.29:4000",

    }
};

export const { BASE_URL, SOCKET_URL } = CONFIG[ENV];
export const TOKEN_URL = `${getDomainName()}/user/dematconnected`;
export const API_URL = `${BASE_URL}/api/v4`;
const WEBHOOK__URL = "https://webhook.traderstoolkits.com/api/v4";
//  DOMAIN + BRANDING
export const domain_name_flat = getDomainName(true);
export const IS_ALGODELTA_DOMAIN = isAlgoDeltaDomain(domain_name_flat);
// WEBHOOK URL LOGIC
const WEBHOOK_BASE_URL = IS_ALGODELTA_DOMAIN ? API_URL : WEBHOOK__URL;
export const CUSTOM_BRIDGE_WEB_HOOK_URL = `${WEBHOOK_BASE_URL}/users/bridge/webhook/`

export const JSON_WEB_HOOK_URL = `${WEBHOOK_BASE_URL}/users/jsonbridge/webhook/`

export const CHARTINK_WEB_HOOK_URL = `${WEBHOOK_BASE_URL}/users/chartink/webhook/`

// STATIC PATHS
export const WHITE_LABEL_LOGO_PATH = `${BASE_URL}/whitelabel_images/`;
// SECURITY KEY
export const RECAPTCHA_SITE_KEY = "6Le0TH4rAAAAAARJgmGk3g-wg07-sw-KHXYQAhaz"
// BRAND LOGO PATHS
export const PORTAL_LOGO_MINI = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.VERTICAL_LOGO}.jpg`;
export const PORTAL_LOGO_LONG = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.HORIZONTAL_LOGO}.jpg`;
export const PORTAL_LOGIN_BG = `${WHITE_LABEL_LOGO_PATH}${domain_name_flat}_${LOGO_TYPE.LOGIN_BG}.jpg`;

